/**
 * State Manager
 * Handles game state persistence and high scores
 */

class StateManagerClass {
    constructor() {
        this.STORAGE_KEY = 'quantato_outlier_state';

        this.state = {
            highScore: 0,
            totalPlays: 0,
            totalDeaths: 0,
            longestSurvival: 0,
            difficultyMultiplier: 1.0,
            settings: {
                masterVolume: 0.5,
                screenshakeEnabled: true
            }
        };

        this.load();
    }

    load() {
        try {
            const saved = localStorage.getItem(this.STORAGE_KEY);
            if (saved) {
                const parsed = JSON.parse(saved);
                this.state = { ...this.state, ...parsed };
            }
        } catch (e) {
            console.warn('Failed to load game state:', e);
        }
    }

    save() {
        try {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.state));
        } catch (e) {
            console.warn('Failed to save game state:', e);
        }
    }

    getHighScore() {
        return this.state.highScore;
    }

    updateHighScore(score) {
        if (score > this.state.highScore) {
            this.state.highScore = score;
            this.save();
            return true; // New high score!
        }
        return false;
    }

    recordPlay() {
        this.state.totalPlays++;
        this.save();
    }

    recordDeath() {
        this.state.totalDeaths++;
        this.save();
    }

    recordSurvivalTime(time) {
        if (time > this.state.longestSurvival) {
            this.state.longestSurvival = time;
            this.save();
        }
    }

    getDifficultyMultiplier() {
        return this.state.difficultyMultiplier;
    }

    increaseDifficulty(amount = 0.1) {
        this.state.difficultyMultiplier += amount;
        this.save();
    }

    resetDifficulty() {
        this.state.difficultyMultiplier = 1.0;
        this.save();
    }

    getSettings() {
        return this.state.settings;
    }

    updateSettings(newSettings) {
        this.state.settings = { ...this.state.settings, ...newSettings };
        this.save();
    }

    // Reset all progress (for debugging or player choice)
    resetAll() {
        this.state = {
            highScore: 0,
            totalPlays: 0,
            totalDeaths: 0,
            longestSurvival: 0,
            difficultyMultiplier: 1.0,
            settings: {
                masterVolume: 0.5,
                screenshakeEnabled: true
            }
        };
        this.save();
    }
}

// Singleton export
export const stateManager = new StateManagerClass();
